export class ModalIdRequiredError extends Error {

  constructor() {
    super('Modal id is required...');
  }
}
